import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, FileText, Download, ShieldCheck } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { STATIC_DOCS } from "../content/siteContent";

const AGREEMENT_TEXT = `YURT DIŞI SAĞLIK HİZMETİNE İLİŞKİN ARACILIK SÖZLEŞMESİ

1. TARAFLAR
Şirket: 2D Sağlık Turizm Danışmanlık A.Ş. — Kanlıca Mah. Hacı Muhittin Sk. No:10 Beykoz/İstanbul. Vergi No: BEYKOZ – 0012475414. Yetkili: Gülnihal Sezer.
Hizmet Alan (Hasta): Ad-Soyad / T.C. Kimlik No / Adres (başvuru sırasında alınır).

2. SÖZLEŞMENİN NİTELİĞİ
İşbu sözleşmenin konusu, Hizmet Alan'ın Japonya'da faaliyet gösteren I-Cell Networks CORP nezdinde değerlendirilmesi amacıyla gerekli başvuruların yapılması, iletişimin sağlanması ve seyahat-konaklama organizasyonunun gerçekleştirilmesine ilişkin aracılık hizmetlerinin şartlarının belirlenmesidir. Şirket, işbu sözleşme kapsamında tıbbi teşhis ve tedavi hizmeti sunmamaktadır; yalnızca aracılık ve organizasyon hizmeti sunmaktadır.

3. ŞİRKETİN ROLÜNÜN SINIRLANDIRILMASI
Şirket yalnızca organizasyon sağlar; tedavi sürecine müdahil değildir; sağlık kuruluşları bağımsızdır.

4. HİZMET KAPSAMI
4.1. Hizmet Alan tarafından sağlanan tıbbi rapor ve belgeler, Şirket tarafından Japonya'daki ilgili kuruluşa iletilir.
4.2. Japonya'daki kuruluş tarafından ön değerlendirme yapılır.
4.3. Uygun görülmesi halinde taraflar arasında online görüşme organize edilir.
4.4. Hizmet Alan'ın kabulü halinde Şirket uçak bileti, konaklama, tercümanlık, transfer ve lojistik destek organizasyonu sağlar.
4.5. Şirket, Japonya'daki sağlık kuruluşunun sunduğu tıbbi hizmetlerin içeriği, kalitesi veya sonuçları hakkında herhangi bir taahhütte bulunmaz.

5. ŞİRKETİN YÜKÜMLÜLÜKLERİ
Belgelerin doğru ve eksiksiz iletilmesini sağlamak; süreci makul özen çerçevesinde yürütmek; organizasyon hizmetlerini sağlamak; Hizmet Alan'ı süreç hakkında bilgilendirmek.

6. HİZMET ALANIN YÜKÜMLÜLÜKLERİ
Tüm sağlık bilgilerini doğru ve eksiksiz sunmak; bilgilerin doğruluğundan sorumlu olmak; pasaport, vize ve resmi işlemleri yerine getirmek (aksi kararlaştırılmadıkça); ücretleri zamanında ödemek.

7. ÜCRET VE İADE
Hizmet Alan tarafından ödenen toplam bedelin bir kısmı, yurt dışındaki sağlık kuruluşuna aktarılmak üzere Şirket nezdinde emanet olarak tutulur; bu tutar Şirket'in geliri değildir. Hizmet bedeli ödendikten sonra Şirket'in kusurundan kaynaklanmayan sebeplerle noter kanalıyla yapılan fesihte ücret iadesi yapılmaz.

8. SORUMLULUĞUN SINIRLANDIRILMASI
Şirket tıbbi hizmet sunmadığından tedavi sonuçlarından sorumlu değildir. Japonya'daki sağlık kuruluşunun eylem ve işlemlerinden Şirket sorumlu tutulamaz. Vize reddi, uçuş iptali gibi mücbir sebeplerden doğan aksaklıklardan Şirket sorumlu değildir.

9. KİŞİSEL VERİLER
Hizmet Alan, sağlık verileri dahil kişisel verilerinin yurt dışına aktarılmasına açık rıza verdiğini kabul eder. Veriler yalnızca hizmetin ifası amacıyla kullanılır.

10. SÖZLEŞMENİN SÜRESİ VE FESİH
Sözleşme imza tarihinde yürürlüğe girer. Taraflar yazılı bildirimle feshedebilir. Fesih halinde yapılan masraflar Hizmet Alan'a yansıtılır.

11. UYUŞMAZLIKLAR
İşbu sözleşmeden doğacak uyuşmazlıklarda İstanbul Mahkemeleri ve İcra Daireleri yetkilidir.

12. DİĞER HÜKÜMLER
Bu sözleşme 12 maddeden oluşmaktadır. Taraflar, sözleşmeyi okuyup anladıklarını kabul eder.`;

const KVKK_SUMMARY_TR = `KVKK AYDINLATMA VE ONAM FORMU — ÖZET (Orijinali Japonca/İngilizce'dir, indirilebilir)

Tıbbi turizm kapsamında tedavi başvurunuza ilişkin kişisel verileriniz (uyruk, adres, ad-soyad, yaş, cinsiyet, telefon, e-posta, tanı raporları, tetkik sonuçları, yatış-taburcu kayıtları, hastalık öyküsü, görüntü verileri, tedavi ve reçete bilgileri, doktorunuza iletilecek notlar) aşağıdaki çerçevede işlenir:

1. KULLANIM AMAÇLARI
• Tedavi başvurunuzun alınması
• Japonya'daki sağlık kuruluşlarının tedaviyi kabul edip edemeyeceğinin teyidi
• Sağlık kuruluşu ile görüşmelerinizde tercümanlık yoluyla uygun tedavi almanızın sağlanması
• Tedavi sonuçlarının size ve/veya ailenize raporlanması
• Başvurularınızda kimlik teyidi
• Şirket içi idari işleyişin yürütülmesi
• Yasal ve idari yükümlülüklerin yerine getirilmesi
• Önceden açık rıza verdiğiniz diğer amaçlar
Bu amaçlar dışında kullanım, ancak size açıklama yapılıp ayrıca onay alınarak gerçekleştirilir.

2. ÜÇÜNCÜ TARAFLARA AKTARIM
Önceden onayınız olmaksızın verileriniz dışarıya verilmez. Ancak tedaviyi kabul edip etmeyeceklerini teyit etmek amacıyla Japonya'daki sağlık kuruluşlarına, gerekli kapsamda aktarım yapılabilir.

3. HİZMET ALIMLARI
Tercümanlık ve imha gibi bazı işler dış hizmet sağlayıcılara yaptırılabilir; bu kuruluşlar kişisel veri koruması bakımından sözleşmeyle denetlenir.

4. HAKLARINIZ
Verilerinize ilişkin açıklama, düzeltme, silme veya kullanımın durdurulmasını talep edebilirsiniz.

Onay vermemeniz halinde tıbbi turizm kapsamında tedavi başvurunuz kabul edilemeyebilir. Onayınızı belirli bir kullanım amacı bakımından dilediğiniz zaman geri çekebilirsiniz.

İmzalayarak yukarıdaki bilgileri okuyup anladığınızı beyan etmiş olursunuz.
I-Cell Networks Co., Ltd. — Başkan: Masayuki Yokose. Kişisel Veri Koruma Sorumlusu: Noriyuki Ishibashi. İletişim: 03-5220-5400`;

export function ConsentModal({ docKey, onClose }) {
  const doc = STATIC_DOCS.find((d) => d.key === docKey);
  if (!doc) return null;
  const text = docKey === "kvkk" ? KVKK_SUMMARY_TR : AGREEMENT_TEXT;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-[90] bg-black/50 backdrop-blur-sm flex items-center justify-center p-4"
        onClick={onClose}
        data-testid={`consent-modal-${docKey}`}
      >
        <motion.div
          initial={{ opacity: 0, y: 30, scale: 0.97 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="bg-white rounded-3xl max-w-2xl w-full max-h-[80vh] flex flex-col shadow-2xl"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex items-center justify-between p-6 border-b border-black/5">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-2xl bg-brand/10 text-brand flex items-center justify-center"><FileText size={18} /></div>
              <h3 className="font-heading font-bold text-ink">{doc.title.tr}</h3>
            </div>
            <button data-testid={`consent-modal-close-${docKey}`} onClick={onClose} className="w-9 h-9 rounded-full hover:bg-black/5 flex items-center justify-center text-sub">
              <X size={18} />
            </button>
          </div>
          <div className="p-6 overflow-y-auto text-sm text-ink/70 leading-relaxed whitespace-pre-wrap">{text}</div>
          <div className="p-6 border-t border-black/5 flex items-center justify-between gap-3">
            <a href={doc.file} download data-testid={`consent-modal-download-${docKey}`} className="flex items-center gap-2 text-sm font-semibold text-brand hover:underline">
              <Download size={15} /> İmzalanabilir belgeyi indir (.docx)
            </a>
            <button data-testid={`consent-modal-ok-${docKey}`} onClick={onClose} className="px-6 h-10 rounded-full bg-ink text-white text-sm font-semibold hover:bg-black transition-colors">
              Okudum, anladım
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}

export function ConsentCheckboxes({ kvkk, agreement, onKvkk, onAgreement, requireBoth = true }) {
  const { t } = useLang();
  const [openDoc, setOpenDoc] = useState(null);

  const Box = ({ checked, onChange, prefix, link, suffix, docKey, testid }) => (
    <label data-testid={testid} className="flex items-start gap-3 cursor-pointer select-none group">
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} className="mt-0.5 w-4.5 h-4.5 w-[18px] h-[18px] rounded accent-[#0066CC] shrink-0 cursor-pointer" data-testid={`${testid}-input`} />
      <span className="text-xs sm:text-sm text-ink/70 leading-relaxed">
        {prefix}
        <button type="button" data-testid={`${testid}-link`} onClick={(e) => { e.preventDefault(); setOpenDoc(docKey); }} className="text-brand font-semibold hover:underline">
          {link}
        </button>
        {suffix}
      </span>
    </label>
  );

  return (
    <div className="space-y-3.5 rounded-2xl border border-black/10 bg-mist/60 p-5" data-testid="consent-boxes">
      <div className="flex items-center gap-2 text-xs font-semibold text-ink/60 uppercase tracking-wider">
        <ShieldCheck size={14} className="text-brand" /> Onam & Sözleşme
      </div>
      <Box checked={kvkk} onChange={onKvkk} prefix={t("consent_kvkk_prefix")} link={t("consent_kvkk_link")} suffix={t("consent_kvkk_suffix")} docKey="kvkk" testid="consent-kvkk" />
      {requireBoth && (
        <Box checked={agreement} onChange={onAgreement} prefix={t("consent_agreement_prefix")} link={t("consent_agreement_link")} suffix={t("consent_agreement_suffix")} docKey="agreement" testid="consent-agreement" />
      )}
      {openDoc && <ConsentModal docKey={openDoc} onClose={() => setOpenDoc(null)} />}
    </div>
  );
}
